import React, { useEffect, useState } from "react";
import "./Details.css";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import { GetBannerById, api_url } from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";

function ViewBanner() {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [mediaData, setMediaData] = useState([]);
  const { mediaid } = useParams();
  const [loading, setLoading] = useState(false);

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    const readableFormat = date.toLocaleString(undefined, options);
    return readableFormat.substring(0, readableFormat.length - 9);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await GetBannerById(
          mediaid,
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setMediaData(response?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [mediaid]);

  return (
    <div className="dashboard-content">
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Banner Details</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/banner" className="btn btn-primary addSeller">
              <Icon className="eye" icon={eye} size={18} /> View All
            </NavLink>
            {/* <NavLink to={`/editBanner/${mediaid}`} className="btn btn-primary addSeller"><Icon className="arrowUpRight" icon={arrowUpRight} size={18} /> Edit</NavLink> */}
          </div>
        </div>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div className="detailsBox">
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover w-100">
                    <tbody>
                      <tr>
                        <th>Title</th>
                        <td>{mediaData?.title}</td>
                      </tr>
                      <tr>
                        <th>Image</th>
                        <td>
                          <img
                            width="100px"
                            height="100px"
                            src={`${api_url}/product/category/getSubcategoryImage/${mediaData?.image}`}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Widget</th>
                        <td>
                          {mediaData.widgets?.map((widget, index) => (
                            <div key={index}>{widget.title}</div>
                          ))}
                        </td>
                      </tr>
                      <tr>
                        <th>Status</th>
                        <td>{mediaData?.statusInfo?.status}</td>
                      </tr>
                      <tr>
                        <th>Created By</th>
                        <td>{mediaData?.createdby}</td>
                      </tr>
                      <tr>
                        <th>Modified By</th>
                        <td>{mediaData?.modifiedby}</td>
                      </tr>
                      <tr>
                        <th>Created Date</th>
                        <td>{formatUTCDate(mediaData?.createddate)}</td>
                      </tr>
                      <tr>
                        <th>Modified Date</th>
                        <td>{formatUTCDate(mediaData?.modifieddate)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default ViewBanner;
